module.exports = __webpack_public_path__ + "img/tangFour.93ac87e8.png";